<div class="main-container">
  <div class="flex-grow" *ngIf="!!entityPage">
    <div
      *ngIf="entityPage  == EntityType.SCIENTIFIC_ARCHIVE_DOCUMENTS || entityPage  == EntityType.SCIENTIFIC_ARCHIVE_FOLDERS"
      class="entity-page-container" role="dialog" aria-labelledby="entity-modal-label">
      <div class="close-icon-container">
        <p-button icon="pi pi-times" [autofocus]="true" [rounded]="true" [text]="true"
          [ariaLabel]=" 'iaa.aria.close' | translate " (click)="onCloseEntityPage()"
          (keydown.enter)="onCloseEntityPage()" [tabindex]="0"></p-button>
      </div>
      <app-scientific-archive-document *ngIf="entityPage === EntityType.SCIENTIFIC_ARCHIVE_DOCUMENTS"
        [closeClicked]="closeClicked" [currentLanguage]="currentLanguage$"></app-scientific-archive-document>
      <app-scientific-archive-folder *ngIf="entityPage === EntityType.SCIENTIFIC_ARCHIVE_FOLDERS"
        [closeClicked]="closeClicked" [currentLanguage]="currentLanguage$"></app-scientific-archive-folder>
    </div>
    <app-conservation-archive-document *ngIf="entityPage === EntityType.CONSERVATION_ARCHIVE_DOCUMENTS"></app-conservation-archive-document>
    <app-conservation-archive-folder *ngIf="entityPage === EntityType.CONSERVATION_ARCHIVE_FOLDERS"></app-conservation-archive-folder>
    <app-hb-section *ngIf="entityPage === EntityType.HB_SECTION"></app-hb-section>
    <object *ngIf="entityPage === EntityType.OBJECT"></object>
    <coin *ngIf="entityPage === EntityType.COIN"></coin>
    <hachraza *ngIf="entityPage === EntityType.HACHRAZA" [currentLanguage]="currentLanguage$"></hachraza>
    <locus *ngIf="entityPage === EntityType.LOCUS" />
    <excavation *ngIf="entityPage === EntityType.EXCAVATION" />
    <survey *ngIf="entityPage === EntityType.SURVEY" />
    <fragment *ngIf="entityPage === EntityType.FRAGMENT"></fragment>
    <manuscript *ngIf="entityPage === EntityType.MANUSCRIPT" />
    <app-model *ngIf="entityPage === EntityType.PHOTOGRAMMETRIC"></app-model>
    <plaster-sample *ngIf="entityPage === EntityType.PLASTER_SAMPLE" />
  </div>
  <div class="flex-grow" [ngClass]="{'hidden': !!entityPage}">
    <div class="search-container">
      <app-search-advanced />
    </div>
    <div>
      <div class="main-right">
        <div class="results">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  </div>
  <div class="footer">
    <div class="unique-uri-bar" [style.visibility]="uniqueUri ? 'visible' : 'hidden'">
        <span>{{ 'iaa.general.uniqueId' | translate }}: </span>
        <a [href]="uniqueUri" target="_blank" dir="ltr">{{ uniqueUri }}</a>
        <button class="copy-btn" (click)="copyToClipboard(uniqueUri)" [title]="'iaa.general.copyUniqueId' | translate">
          <i [class]="copied ? 'pi pi-check' : 'pi pi-copy'"></i>
        </button>
        <span class="copied-msg" *ngIf="copied">{{ 'iaa.general.uniqueIdCopied' | translate }}</span>
    </div>
        <version-info></version-info>
  </div>
</div>